import { render } from "./lnfhrz.vue?vue&type=template&id=2d6d8683&scoped=true&ts=true"
import script from "./lnfhrz.vue?vue&type=script&lang=ts"
export * from "./lnfhrz.vue?vue&type=script&lang=ts"

import "./lnfhrz.vue?vue&type=style&index=0&id=2d6d8683&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6d8683"]])

export default __exports__